import { Component, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StyleClassModule } from 'primeng/styleclass';
import { MenubarModule } from 'primeng/menubar';
import { TooltipModule } from 'primeng/tooltip';
import { take, Observable, Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { UserMenuDropdown } from '@/shared/user-menu-dropdown/user-menu-dropdown';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SessionData } from '../../../helper/auth.helper';
import { ThemeHelper } from '../../../helper/theme.helper';
import { AuthService } from '../../../services/auth.service';
import { ThemeService } from '../../../services/theme.service';
import { LayoutService } from '../../service/layout.service';

@Component({
    selector: 'app-home-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, FormsModule, StyleClassModule, MenubarModule, TooltipModule, TranslateModule, UserMenuDropdown, ButtonModule, ToggleSwitchModule],
    templateUrl: 'app-home.topbar.html'
})
export class AppHomeTopbar implements AfterViewInit, OnDestroy {
    items!: MenuItem[];
    themeData: ThemeHelper | undefined;
    sessionData: SessionData | undefined;
    checked: boolean = false;
    private resizeSubscription?: Subscription;
    private sessionSubscription?: Subscription;

    resize$ = new Observable<number>((subscriber) => {
        const emitWidth = () => {
            subscriber.next(window.innerWidth);
        };

        // Emit initial width
        emitWidth();

        // Create ResizeObserver to watch for viewport changes (including dev tools)
        const resizeObserver = new ResizeObserver(emitWidth);
        resizeObserver.observe(document.body);

        // Also listen to window resize events as fallback
        window.addEventListener('resize', emitWidth);

        // Cleanup
        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', emitWidth);
        };
    });

    @HostListener('window:resize', ['$event.target.innerWidth'])
    toggleUserMenu(width: number) {
        const userDropdown = document.querySelector('.layout-topbar-menu') as HTMLDivElement;
        if (width > 1100) {
            userDropdown.classList.remove('hidden');
        } else {
            userDropdown.classList.add('hidden');
        }
    }

    constructor(
        public layoutService: LayoutService,
        private themeService: ThemeService,
        private authService: AuthService
    ) {
        this.resizeSubscription = this.resize$.subscribe((width) => {
            if (width <= 1100 || width > 1417) {
                this.items = this.buildMenuItems();
            } else {
                this.items = this.buildMenuItemsForTablet();
            }
        });
        this.sessionSubscription = this.authService.sessionData.subscribe({
            next: (data) => {
                this.sessionData = data;
            }
        });

        this.themeService.themeData.subscribe({
            next: (data) => {
                this.themeData = data;
            }
        });
    }

    ngAfterViewInit(): void {
        const userDropdown = document.querySelector('.layout-topbar-menu') as HTMLDivElement;
        if (window.innerWidth > 1100) {
            userDropdown.classList.remove('hidden');
        } else {
            userDropdown.classList.add('hidden');
        }
    }

    ngOnDestroy() {
        this.resizeSubscription?.unsubscribe();
        this.sessionSubscription?.unsubscribe();
    }

    private buildMenuItems(): MenuItem[] {
        // Default full menu for non-logistics users
        return [
            {
                label: 'Dashboard',
                icon: 'pi pi-fw pi-home',
                routerLink: '/home'
            },
            {
                label: 'Partnergesellschaften',
                icon: 'pi pi-fw pi-credit-card',
                routerLink: '/home/partner-companies'
            },
            {
                label: 'Provisionsabrechnungen',
                icon: 'pi pi-fw pi-credit-card',
                routerLink: '/home/provisionsabrechnungen'
            }
        ];
    }

    private buildMenuItemsForTablet(): MenuItem[] {
        // Default full menu for non-logistics users
        return [
            {
                label: '',
                icon: 'pi pi-fw pi-home',
                routerLink: '/home'
            },
            {
                label: '',
                icon: 'pi pi-fw pi-credit-card',
                routerLink: '/home/provisionsabrechnungen'
            }
        ];
    }
}
